module.exports = __webpack_public_path__ + "static/media/poweroff.71bcb386.wav";